var map = {
	"./decidim/gamification/badges/decidim_gamification_badges_accepted_proposals.svg": 1663,
	"./decidim/gamification/badges/decidim_gamification_badges_proposal_votes.svg": 41668,
	"./decidim/gamification/badges/decidim_gamification_badges_proposals.svg": 31153,
	"./decidim/proposals/decidim_proposals.svg": 51337,
	"./decidim/proposals/proposal-placeholder-card-g.svg": 77677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41712;